var AuthenticationMode = /* @__PURE__ */ ((AuthenticationMode2) => {
  AuthenticationMode2["BrowserSession"] = "browser-session";
  AuthenticationMode2["APIKey"] = "api-key";
  AuthenticationMode2["Internal"] = "internal";
  AuthenticationMode2["InternalAuthToken"] = "internal-auth-token";
  AuthenticationMode2["Anonymous"] = "anonymous";
  AuthenticationMode2["Custom"] = "custom";
  return AuthenticationMode2;
})(AuthenticationMode || {});
var BrowserSessionStorageType = /* @__PURE__ */ ((BrowserSessionStorageType2) => {
  BrowserSessionStorageType2["Durable"] = "Durable";
  BrowserSessionStorageType2["Session"] = "session";
  BrowserSessionStorageType2["Temporary"] = "temporary";
  return BrowserSessionStorageType2;
})(BrowserSessionStorageType || {});
export {
  AuthenticationMode,
  BrowserSessionStorageType
};
//# sourceMappingURL=ClientOptions.js.map
